"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Returns an object with only the keys listed in the `included` argument.
 *
 * @param obj
 * @param included
 * @returns {*}
 */

var whitelist = exports.whitelist = function whitelist(obj, included) {
  return Object.keys(obj || []).reduce(function (prev, key) {
    if (!included || included.includes(key)) {
      return _extends({}, prev, _defineProperty({}, key, obj[key]));
    } else {
      return prev;
    }
  }, {});
};

/**
 * In the absence of `Set`, we provide a helper function which ensures no two objects with
 * the same `id` occur in an array;
 *
 * @param items
 * @returns {*}
 */

var deduplicateBy = exports.deduplicateBy = function deduplicateBy(key, items) {
  return items.reduce(function (prev, cur) {
    if (!prev.find(function (it) {
      return it[key] === cur[key];
    })) {
      return [].concat(_toConsumableArray(prev), [cur]);
    }
    return prev;
  }, []);
};